import { render, staticRenderFns } from "./contentBlock.vue?vue&type=template&id=014292b3&scoped=true&"
import script from "./contentBlock.vue?vue&type=script&lang=js&"
export * from "./contentBlock.vue?vue&type=script&lang=js&"
import style0 from "./contentBlock.vue?vue&type=style&index=0&id=014292b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014292b3",
  null
  
)

export default component.exports